import BootstrapModal from "react-bootstrap/Modal";
import ModalHeader from "./ModalHeader";

// size: don't change it. We're always using the default size of the modal.
// fullscreen: false (default) // true // "sm-down" (no other options are allowed by our design system)

const Modal = ({
  show = false,
  onHide = () => {},
  closeButton = true,
  title = "",
  Footer = null,
  children,
  ...props
}) => {
  return (
    <BootstrapModal
      show={show}
      onHide={onHide}
      scrollable
      centered
      restoreFocus={false}
      {...props}
    >
      <ModalHeader
        title={title}
        closeButton={closeButton}
        onHide={onHide}
      />

      <BootstrapModal.Body>
        {children}
      </BootstrapModal.Body>

      {Footer && (
        <BootstrapModal.Footer>
          {Footer}
        </BootstrapModal.Footer>
      )}
    </BootstrapModal>
  );
};

export default Modal;
